import classNames from 'classnames';
import AmexLogo from '~/assets/svgs/amex.svg';
import DinersClubLogo from '~/assets/svgs/diners_club.svg';
import Discover from '~/assets/svgs/discover.svg';
import JCB from '~/assets/svgs/jcb.svg';
import MastercardLogo from '~/assets/svgs/mastercard.svg';
import UnionPayLogo from '~/assets/svgs/unionpay.svg';
import VisaLogo from '~/assets/svgs/visa.svg';
import styles from './CardLogos.module.scss';

const CardLogos = () => {
    return (
        <div className={classNames(styles.container, 'flex gap-1 relative')} onClick={(e) => e.stopPropagation()}>
            <VisaLogo />
            <MastercardLogo />
            <DinersClubLogo />
            <div className={classNames(styles.groupContainer, 'relative group')}>
                <div className={classNames(styles.moreButton, 'px-2 border-[#e5e7eb] border rounded')}>+4</div>
                <div
                    className={classNames(
                        styles.hiddenLogos,
                        'absolute invisible group-hover:visible -left-[40px] bottom-full mb-2 scale-90 opacity-0 group-hover:scale-100 group-hover:opacity-100 p-2 text-sm text-white bg-black rounded transition-transform ease-in-out'
                    )}
                >
                    <div className="flex gap-1 w-[80px] flex-wrap">
                        <AmexLogo />
                        <UnionPayLogo />
                        <JCB />
                        <Discover />
                    </div>
                    <div className={classNames(styles.arrow, 'absolute')}></div>
                </div>
            </div>
        </div>
    );
};

export default CardLogos;
